<div
	#menuOption
	class="andromeda-menu-option"
	(click)="onClickOnOption($event)"
>
	<ng-content></ng-content>
</div>
